<template>
    <div class="modal nb-modal-mask" style="display: block">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important; max-width: 800px !important ;">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="def-title" id="exampleModalLabel"> Histórico de Notificações </h4>
           </div>
            <div class="modal-body" style="max-height: 350px; overflow-y: auto;" >
                <span class="text-secondary" style="font-size:15px; font-weight: 500;">Notificações já lidas</span>
                <ul v-for="(not, index) in notificationList" :key="index">
                    <li class="card p-3 my-3 shadow-sm flex-row align-items-center justify-content-between ">
                        <div>
                            <i class="fa fa-envelope-open icon"></i>
                            <span class="assunto-text"><span class="mr-2">#{{not.codnotificacao}} </span>{{not.assunto}}</span>
                        </div>
                        <div class="position-absolute mt-2" style="top: 0; right: 30%">
                            <small class="text-secondary" style="font-size:12px">{{not.data | formatDataHora}}</small>
                        </div>
                        <div class="align-self-end">
                            <button 
                                data-toggle="tooltip"
                                title="Visualizar"
                                class="btn btn-view"
                                @click="handleViewNotification(not)"
                            >
                                <i class="fa fa-eye"></i>
                            </button>
                            <!-- <button 
                                class="btn btn-trash"
                                data-toggle="tooltip"
                                title="Excluir"
                                @click="handleDeleteNotification(not)"
                            >
                                <i class="fa fa-trash"></i>
                            </button> -->
                        </div>
                    </li>
                </ul>
            </div>
            <div class="modal-footer">
              <button  type="button" ref="btnClose" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="$emit('close')"> Fechar </button>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
export default {
    computed:{
        notificationList: function(){
            let notifications = [];

            if (!this.$store.getters.getNotificationsList || !this.$store.getters.getNotificationsList.length)
                return notifications;
            
            let notifications_status_1 = this.$store.getters.getNotificationsList.filter((e)=> e.status_usuario == '1' );
            
            notifications_status_1.forEach((e)=>{
                notifications.push(e);
            })

            return notifications;
            
        }
    },
    methods:{
        handleDeleteNotification(not){
            not.status = 0
            this.$emit('cancel', not)
        },
        handleViewNotification(not){
            this.$emit('view', not)
        },
        async loadNotifications(next){
            if (next) {
                this.offset = next;
            }

            let params = { }
            if (this.offset) {
                params.offset = this.nextPage;
            }

            await this.$store.dispatch('loadNotificationsList', params );
            this.offset = false;
        },
    },
    created(){
        this.loadNotifications();
    }
}
</script>

<style scoped>
ul li{
    list-style-type: none;
    padding: 0;
    margin:0 ;
}
ul{
    padding: 0;
    margin: 0 ;
}

.icon{
	color:#2b6292;
    font-size: 25px;
}
.btn-view i{
    color: #2b6292;
    font-size: 18px;
}
.btn-trash{
    color: #f74040;
    font-size: 18px;
}
.assunto-text{
    color: #2b6292 ;
    font-size: 15px;
    font-weight: 700;
    margin-left: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/notification-history.vue